import { CancelCallButton, OwnCapability, ReactionsButton, Restricted, SpeakerLayout, SpeakingWhileMutedNotification, ToggleAudioPublishingButton, ToggleVideoPublishingButton, useCall } from "@stream-io/video-react-sdk";
import React from "react";
import { useStream } from "../hooks/useStream";
import { useLocation } from "react-router-dom";

const DialogActiveCall = () => {
    const location = useLocation();
    const call = useCall();
    const { leaveCall } = useStream();

    if(location.pathname === "/home/chat/call") {
        return null;
    }

    if(! call)
        return null;

    return <div className="hidden fixed bottom-0 right-0 w-[3000px] h-[300px]">
        <div className="text-white max-w-full max-h-full flex flex-col">
            <div className="flex-1 relative flex overflow-y-auto">
                <SpeakerLayout />
            </div>
            <div className="flex-none">
                <div className="str-video__call-controls">
                    <Restricted requiredGrants={[OwnCapability.SEND_AUDIO]}>
                        <SpeakingWhileMutedNotification>
                            <ToggleAudioPublishingButton />
                        </SpeakingWhileMutedNotification>
                    </Restricted>
                    <Restricted requiredGrants={[OwnCapability.SEND_VIDEO]}>
                        <ToggleVideoPublishingButton />
                    </Restricted>
                    <Restricted requiredGrants={[OwnCapability.CREATE_REACTION]}>
                        <ReactionsButton />
                    </Restricted>
                    <CancelCallButton onLeave={() => {
                        leaveCall();
                    }} />
                </div>
            </div>
        </div>
    </div>;
}

export default DialogActiveCall;